import { NgModule } from '@angular/core';
import { DeviceTypeTranslationPipe } from './device-type-translation/device-type-translation.pipe';

@NgModule({
  declarations: [DeviceTypeTranslationPipe],
  exports: [DeviceTypeTranslationPipe],
  providers: [DeviceTypeTranslationPipe],
})
export class DevicesStoreSharedModule {}
